import { Button, Col, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { routeMapMini } from '../../constants/routeMap'
import JoinRuleTable from './join-rule.table'

function JoinRule(): JSX.Element {
    return (
        <div>
            <div
                style={{
                    float: 'left',
                    marginLeft: '15px',
                    marginTop: '10px',
                    marginBottom: '10px',
                }}
            >
                <Row gutter={[10, 0]}>
                    <Col>
                        <Link to={routeMapMini.rulesJoinNew}>
                            <Button type="primary">Create New Rule</Button>
                        </Link>
                    </Col>
                </Row>
            </div>
            <div style={{ margin: '15px' }}>
                <JoinRuleTable />
            </div>
        </div>
    )
}

export default JoinRule
